<script setup lang="ts">
  import DetailSection from "./DetailSection.vue";
  import DetailItem from "./DetailItem.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo;
  }>();
</script>

<template>
  <DetailSection title="Target">
    <DetailItem
      label="Description"
      :value="histo.hs_target_description" />
    <DetailItem
      label="Quotas"
      :value="histo.hs_quotas" />
    <DetailItem
      label="Type"
      :value="histo.hs_target_b2b_b2c" />
    <DetailItem
      label="Incidence"
      :value="histo.pricer_incidence" />
    <DetailItem
      label="Additional IR"
      :value="histo.pricer_additional_incidence" />
  </DetailSection>
</template>
